import { Routes, Route, Navigate } from 'react-router-dom';
import { useEffect } from 'react';
import { useAuthStore } from '@/store';
import { verifyAuth } from '@/api';
import Layout from '@/components/Layout';
import ThreadList from '@/components/ThreadList';
import ThreadDetail from '@/components/ThreadDetail';
import Dashboard from '@/components/Dashboard';
import Settings from '@/components/Settings';
import Login from '@/components/Login';
import { Toaster } from '@/components/ui/Toaster';

function App() {
  const { setAuth, clearAuth, isAuthenticated } = useAuthStore();

  useEffect(() => {
    // Verify auth on load (Cloudflare Access provides Cf-Access-Authenticated-User-Email header)
    const initAuth = async () => {
      try {
        const result = await verifyAuth();
        if (result.ok && result.data) {
          setAuth(result.data, 'access-token'); // Token is handled by Cloudflare Access
        } else {
          clearAuth();
        }
      } catch {
        clearAuth();
      }
    };
    initAuth();
  }, [setAuth, clearAuth]);

  return (
    <div className="min-h-screen bg-gray-50">
      <Toaster />
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          path="/*"
          element={
            isAuthenticated ? (
              <Layout>
                <Routes>
                  <Route path="/" element={<Navigate to="/inbox" replace />} />
                  <Route path="/inbox" element={<ThreadList />} />
                  <Route path="/inbox/:threadId" element={<ThreadDetail />} />
                  <Route path="/dashboard" element={<Dashboard />} />
                  <Route path="/settings" element={<Settings />} />
                </Routes>
              </Layout>
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
      </Routes>
    </div>
  );
}

export default App;